// @ts-check
import { createGame } from './app/create-game.js';
const game = createGame();
if (import.meta.hot) {
  import.meta.hot.accept();
  import.meta.hot.dispose(() => game.dispose());
}
